module.exports = __webpack_public_path__ + "b6010d0e2d0ea8894e541b26da04c240.MP3";